import { createSelector } from 'reselect';

import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as StartPageConstants from 'store/startPage/constants';
import * as StartPageSelectors from 'store/startPage/selectors';

const selectRootState = (state) => {
  return state;
};

export const interlayerSelectCarInstanceId = createSelector(selectRootState, (state) => {
  const fromCarInstance = CarInstanceSelectors.selectValuesField(
    CarInstanceConstants.VALUE_FIELDS.ID
  )(state);
  const fromStartPage = StartPageSelectors.selectCarInstanceId(state);

  return [fromCarInstance, fromStartPage].find(Boolean);
});

export const interlayerSelectCustomerId = createSelector(selectRootState, (state) => {
  const application = StartPageSelectors.selectField(StartPageConstants.FIELDS.APPLICATION)(state);
  const customer = StartPageSelectors.selectField(StartPageConstants.FIELDS.CUSTOMER)(state);

  const { [StartPageConstants.APPLICATION_FIELDS.CUSTOMER]: applicationCustomer } =
    application ?? {};
  const { id: fromApplication } = applicationCustomer ?? {};
  const { id: fromCustomer } = customer ?? {};

  return [fromApplication, fromCustomer].find(Boolean);
});
